function Faq() {
   
    return (
        <div className="h-screen overflow-auto">
            <h1 className="font-bold">Faq</h1>
        </div>
    )
};
export default Faq;